import {
	type EditorState,
	TextSelection,
	type Transaction,
} from '@atlaskit/editor-prosemirror/state';

import { ACTIONS } from '../types/types';

import { aiAutocompletePluginKey } from './plugin-key';

/**
 * Accepts the current suggestion:
 *
 * • manual: inserts the suggestion text inline at the original cursor position.
 *   Dispatched when the user presses Tab.
 */
export const acceptSuggestionCommand = (
	state: EditorState,
	dispatch?: (tr: Transaction) => void,
): boolean => {
	const pluginState = aiAutocompletePluginKey.getState(state);
	if (pluginState?.status !== 'suggestion') {
		return false;
	}
	if (!dispatch) {
		return false;
	}

	// manual trigger — insert text inline at the original cursor position
	const { cursorPos, suggestion } = pluginState;
	const textNode = state.schema.text(suggestion);
	const tr = state.tr.insert(cursorPos, textNode);
	// Place cursor after the inserted text
	const newCursorPos = cursorPos + suggestion.length;
	tr.setSelection(TextSelection.create(tr.doc, newCursorPos))
		.setMeta(aiAutocompletePluginKey, { type: ACTIONS.DISMISS })
		.setMeta('addToHistory', true);

	dispatch(tr);
	return true;
};

/**
 * Dismisses the current suggestion without inserting anything.
 * Used for Escape key and any other dismiss trigger.
 */
export const dismissSuggestionCommand = (
	state: EditorState,
	dispatch?: (tr: Transaction) => void,
): boolean => {
	const pluginState = aiAutocompletePluginKey.getState(state);
	if (!pluginState || pluginState.status === 'idle') {
		return false;
	}
	if (!dispatch) {
		return false;
	}

	const tr = state.tr.setMeta(aiAutocompletePluginKey, { type: ACTIONS.DISMISS });
	dispatch(tr);
	return true;
};
